import React from "react";

import { getBlockTypeIcon } from "./BlockAutocompleteDropdown";

export interface BlockContextBadgeProps {
  blockTitle: string;
  /** Block type, used to pick the matching icon. Falls back to the generic dashboard icon. */
  blockType?: string;
  onRemove?: () => void;
}

export const BlockContextBadge: React.FC<BlockContextBadgeProps> = ({
  blockTitle,
  blockType,
  onRemove,
}) => {
  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 bg-gray-100 border border-gray-200 rounded-full text-sm align-middle cursor-default">
      <span className="material-icons text-blue-600" style={{ fontSize: "14px" }}>
        {blockType ? getBlockTypeIcon(blockType) : "space_dashboard"}
      </span>

      <span className="text-gray-900 truncate max-w-[150px] font-medium" title={blockTitle}>
        {blockTitle}
      </span>

      {onRemove && (
        <button
          onClick={() => {
            onRemove();
          }}
          className="text-gray-400 hover:text-gray-600 flex items-center cursor-pointer"
          title="Remove from message"
        >
          <span className="material-icons" style={{ fontSize: "14px" }}>
            close
          </span>
        </button>
      )}
    </span>
  );
};
